<template xmlns="http://www.w3.org/1999/html">
    <div>

        <ValidationObserver ref="form">
            <b-row>
                <b-col sm="12">
                    <h5 class="h5-color">
                        <span class="header-icon"><i class="nav-icon icon-direction"></i></span>
                        Your Customer Details
                    </h5>
                </b-col>
            </b-row>

            <ValidationProvider
                    vid="prefered_language"
                    name="Customer Preferred Language"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Customer Preferred Language <span style="color:red">*</span></label>
                            <b-form-group>
                            <b-form-radio-group id="radio-group-2" v-model="ProposerData.prefered_language" name="radio-sub-component">
                                <b-form-radio value="Sinhala">Sinhala</b-form-radio>
                                <b-form-radio value="Tamil">Tamil</b-form-radio>  
                                <b-form-radio value="English">English</b-form-radio> 
                            </b-form-radio-group>
                            </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="receive_notification"
                    name="Customer Preferred Language"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Receive Notifications <span style="color:red">*</span></label>
                            <b-form-group>
                            <b-form-radio-group v-on:input="checkPreferMode()" id="radio-group-2" v-model="ProposerData.receive_notification" name="radio-sub-component-1">
                                <b-form-radio value="1">Yes</b-form-radio>
                                <b-form-radio value="2">No</b-form-radio>  
                            </b-form-radio-group>
                            </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>
 
            <ValidationProvider
                    vid="prefered_communication"
                    name="Preferred Mode of Communication"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Preferred Mode of Communication <span v-if="ProposerData.receive_notification == 1" style="color:red">*</span></label>
                        <b-form-group>
                        <b-form-checkbox-group v-on:input="checkEmailRequire()" :disabled="ProposerData.receive_notification == 2"   id="checkbox-group-2" v-model="ProposerData.prefered_communication" name="flavour-2">
                            <b-form-checkbox  value="SMS">Mobile/SMS</b-form-checkbox>
                            <b-form-checkbox  value="Telephone">Telephone</b-form-checkbox> 
                             <b-form-checkbox  value="Email">Email</b-form-checkbox> 
                        </b-form-checkbox-group>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0] && ProposerData.receive_notification == 1">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-if="errors[0] && ProposerData.receive_notification == 1" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="adr_line1"
                    name="Address(Line1)"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Address(Line1) <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.adr_line1"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Line1"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="adr_line2"
                    name="Line2"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Line2 <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.adr_line2"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Line2"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="adr_line3"
                    name="Line3"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Line3</label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.adr_line3"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Line3"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div v-if="errors[0]" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="city"
                    name="City"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">City <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <b-col md="12" class="">
                                    <v-select
                                            label="name"
                                            @input="setCityList"
                                            :options="city_list"
                                            :reduce="data => data.code"
                                            :value="ProposerData.city"
                                            placeholder="--PLEASE SELECT--"
                                    ></v-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="email_address"
                    name="Email Address"
                    v-slot="{ errors }"
                    rules="email">
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Email Address <span v-if="email_require" style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.email_address"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Email Address"
                                            @change="draftProposalData"></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0] && email_require">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-if="errors[0] && email_require" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="nic"
                    name="NIC"
                    v-slot="{ errors }"
                    rules="">
                <!--Regex Rule-->
                <!--:rules="{ regex: /^\d{12}$|[0-9]{9}[vVxX]$/ }"-->

                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">NIC <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.nic"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="NIC"
                                            @change="draftProposalData"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4" v-if="ProposerData.customer_type == 1">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                  <b-col cols="12" sm="4" v-if="ProposerData.customer_type == 2">
                    <label class="label-name empty-label"></label>
                    <div v-if="errors[0]" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                    </div>
                  </b-col>

                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="vat_no"
                    name="VAT Number"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">VAT Number</label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.vat_no"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="VAT Number"
                                            class="to-uppercase"
                                            @change="draftProposalData"
                                    ></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div v-if="errors[0]" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="business_occupation"
                    name="Business/ Occupation"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Business/ Occupation <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.business_occupation"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Business/ Occupation"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="source_of_income"
                    name="Source of Income"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Source of Income <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.source_of_income"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Source of Income"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-if="errors[0]" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="garaged_address"
                    name="Address where the vehicle usually Garaged"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Address where the vehicle usually Garaged</label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="ProposerData.garaged_address"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Address where the vehicle usually Garaged"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div v-if="errors[0]" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <b-row>
                <b-col sm="12">
                    <h5 class="h5-color">
                        <span class="header-icon"><i class="nav-icon icon-direction"></i></span>
                        Your Ownership Details
                    </h5>
                </b-col>
            </b-row>

            <ValidationProvider
                    vid="owner_name"
                    name="Name of the Owner"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Name of the Owner <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="OwnershipData.owner_name"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Name of the Owner"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="registered_owner_name"
                    name="Name of the Registered Owner"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Name of the Registered Owner <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <b-form-input
                                            v-model="OwnershipData.registered_owner_name"
                                            type="text"
                                            id="input-large"
                                            size="lg"
                                            placeholder="Name of the Registered Owner"
                                            @change="draftProposalData"
                                            class="to-uppercase"
                                            v-uppercase></b-form-input>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <ValidationProvider
                    vid="financial_inst_name"
                    name="Name of the institution who has financial interest"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Name of the institution who has financial interest</label>
                        <b-form-group>
                            <b-row>
                                <!-- Passport Number -->
                                <b-col md="12" class="">
                                    <v-select
                                            label="name"
                                            @input="setInsuranceCmpList"
                                            :options="insurance_cmp_list"
                                            :reduce="data => data.code"
                                            :value="OwnershipData.financial_inst_name"
                                            placeholder="--PLEASE SELECT--"
                                    ></v-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div v-if="errors[0]" class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

            <b-row>
                <b-col sm="12">
                    <h5 class="h5-color">
                        <span class="header-icon"><i class="nav-icon icon-direction"></i></span>
                        Driver Details
                    </h5>
                </b-col>
            </b-row>

            <ValidationProvider
                    vid="vehicle_driven_by"
                    name="Vehicle will be driven by"
                    v-slot="{ errors }"
                    rules=""
            >
                <b-row class="row-bottom">
                    <b-col sm="8" md="8">
                        <label class="label-name">Vehicle will be driven by <span style="color:red">*</span></label>
                        <b-form-group>
                            <b-row>
                                <b-col md="12" class="">
                                    <v-select
                                            label="name"
                                            @input="setVehicleDrivenBy"
                                            :options="vehicle_driven_by_list"
                                            :reduce="data => data.code"
                                            :value="DriverData.vehicle_driven_by"
                                            placeholder="--PLEASE SELECT--"
                                    ></v-select>
                                </b-col>
                            </b-row>
                        </b-form-group>
                    </b-col>

                    <b-col cols="12" sm="4">
                        <label class="label-name empty-label"></label>
                        <div class="msg validation-form-msg required-msg" v-if="!errors[0]">
                            <span class="msg-paragraph"><span style="color:red">*</span>This field is required</span>
                        </div>
                        <div v-else class="msg-fail validation-form-msg">
                              <span class="msg-paragraph" v-for="(error, index) in errors" v-bind:key="index">
                                {{ error }}
                              </span>
                        </div>
                    </b-col>
                </b-row>
            </ValidationProvider>

        </ValidationObserver>
    </div>
</template>

<script>
    import {mapState, mapActions} from "vuex";

    export default {
        data: () => {
            return {
                disable_customer_field: true,
                disable_prefered_com : false,
                email_require:false
            };
        },

        computed: {
            ...mapState("proposal", [
                "customer_errors",
                "ProposerData",
                "CustomerData",
                "OwnershipData",
                "OwnershipData",
                "DriverData",
                "vehicle_driven_by_list",
                "city_list",
                "title_list",
                "insurance_cmp_list",
                "ProposalID",
                "all_errors"
            ]),
        },
        props: ["error_tab_customer"],
        methods: {
            ...mapActions("proposal", [
                "setCityList",
                "setTitleList",
                "setVehicleDrivenBy",
                "setInsuranceCmpList",
                "getParameterDataList",
                "draftProposalData"
            ]),
            set_customer_type(value) {
                this.ProposerData.customer_type = value;
            },
            async checkPreferMode(){ 
                if(this.ProposerData.receive_notification == 2){                      
                    this.ProposerData.prefered_communication = [];  
                    this.disable_prefered_com = true;
                }else{
                    this.disable_prefered_com = false;
                }
            },
            async checkEmailRequire(){
                if(this.ProposerData.prefered_communication.includes("Email")){
                    this.email_require = true;
                }else{
                    this.email_require = false;
                }
            }

        },
        watch: {
            'DriverData.vehicle_driven_by'  : function (val, oldval) {
                this.draftProposalData();
            },
            error_tab_customer: function () {
                this.$refs.form.setErrors(this.customer_errors);
            },
            'ProposerData.city'  : function (val, oldval) {
                this.draftProposalData();
            },
            'OwnershipData.financial_inst_name'  : function (val, oldval) {
                this.draftProposalData();
            }

        },
        mounted() {
          let content = document.querySelector(".app-body");
          content.scrollTo(0,0);
        }

    };
</script>

<style scoped>
    .to-uppercase{
        text-transform: uppercase
    }

    input::placeholder {
        font-size: 14px;
        text-transform: uppercase
    }

    .msg-secound-line {
        margin-top: 0px;
    }

    .custom-select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }

    .toggle-button {
        margin: 0 20px;
    }

    /*
         * Toggle button styles
         */
    .toggle-button {
        position: relative;
        display: inline-block;
        color: #fff;
    }

    .toggle-button label {
        display: inline-block;
        text-transform: uppercase;
        cursor: pointer;
        text-align: left;
    }

    .toggle-button input {
        display: none;
    }

    .toggle-button__icon {
        cursor: pointer;
        pointer-events: none;
    }

    .toggle-button__icon:before,
    .toggle-button__icon:after {
        content: "";
        position: absolute;
        top: 45%;
        left: 35%;
        transition: 0.2s ease-out;
    }

    /*
         * Toggle button variables
         */
    /*
         * Toggle button styles
         */
    .toggle-button--aava label {
        height: 50px;
        line-height: 50px;
        transition: all 0.2s;
        border-radius: 2rem;
    }

    .toggle-button--aava label:before,
    .toggle-button--aava label:after {
        position: absolute;
        right: 1.5rem;
        transition: all 0.2s 0.1s ease-out;
    }

    .toggle-button--aava label:before {
        content: attr(data-on-text);
    }

    .toggle-button--aava label:after {
        content: attr(data-off-text);
    }

    .toggle-button--aava input[type="checkbox"] + label {
        width: 120px;
        background: #ff5335;
    }

    .toggle-button--aava input[type="checkbox"] + label:before {
        opacity: 0;
        transform: translate(0, 20px);
    }

    .toggle-button--aava input[type="checkbox"] + label:after {
        opacity: 1;
        transform: translate(0, 0);
    }

    .toggle-button--aava input[type="checkbox"]:checked ~ label {
        width: 120px;
        background: #61b136;
    }

    .toggle-button--aava input[type="checkbox"]:checked ~ label:before {
        opacity: 1;
        transform: translate(0, 0);
    }

    .toggle-button--aava input[type="checkbox"]:checked ~ label:after {
        opacity: 0;
        transform: translate(0, -20px);
    }

    .toggle-button--aava
    input[type="checkbox"]:checked
    ~ .toggle-button__icon:before {
        transform: translate(-10%, 100%) rotate(45deg);
        width: 16.66667px;
    }

    .toggle-button--aava
    input[type="checkbox"]:checked
    ~ .toggle-button__icon:after {
        transform: translate(30%) rotate(-45deg);
    }

    .toggle-button--aava .toggle-button__icon {
        position: absolute;
        left: 0;
        top: 0;
        height: 50px;
        width: 50px;
    }

    .toggle-button--aava .toggle-button__icon:before,
    .toggle-button--aava .toggle-button__icon:after {
        height: 3px;
        border-radius: 3px;
        background: #fff;
        box-shadow: 0 1px 0 rgba(0, 0, 0, 0.1);
    }

    .toggle-button--aava .toggle-button__icon:before {
        width: 25px;
        transform: rotate(45deg);
    }

    .toggle-button--aava .toggle-button__icon:after {
        width: 25px;
        transform: rotate(-45deg);
    }

    .hide {
        display: none;
    }

    .selected_val {
        color: #fff !important;
        background-color: #4b78be !important;
    }

    p {
        color: #717887;
        margin-top: -15px;
        margin-left: 2px;
    }

    .check {
        opacity: 0.5;
        color: #996;
    }

    .box {
        margin-bottom: 5px;
    }

    input[type="radio"],
    input[type="checkbox"] {
        box-sizing: border-box;
        padding: 0;
        display: none;
    }

    img {
        width: 100px;
    }

    .img-thumbnail {
        border: 1px solid #4b78be !important;
        background-color: #ffffff !important;
    }

    .btn-outline {
        border: 1px solid #4b78be !important;
    }

    .btn-pad {
        padding: 0 !important;
    }

    .btn {
        border: solid 0px #e4e7ea;
        border-radius: 0.3rem !important;
    }

    .btn-sq {
        width: 98px !important;
        height: 66px !important;
        font-size: 12px;
        color: #4b78be;
        background-color: #ffffff;
        margin-top: 2px;
    }

    .btn-sqw {
        width: 98px !important;
        height: 105px !important;
        font-size: 12px;
        color: #4b78be;
        background-color: #ffffff;
        margin-top: 2px;
    }

    .btn-ch {
        width: 55px !important;
        height: 58px !important;
        font-size: 12px;
        color: #4b78be;
        background-color: #ffffff;
    }

    .label-name {
        font-weight: bold;
        color: #31607b;
        margin-bottom: 15px !important;
    }

    .label-align {
        text-align: right;
    }

    hr {
        margin-top: 1px !important;
        margin-bottom: 20px !important;
    }

    /* start of validation msg css */

    .msg {
        border: 1px solid #d8e1eb;
        border-radius: 0.2rem;
        padding: 12px;
        background: #f2f6fa;
        margin-bottom: 18px;
        color: #656d7d;
    }

    .msg-fail {
        border: 1px solid #ff969b;
        border-radius: 0.2rem;
        padding: 12px;
        background: #ffeef3;
        margin-bottom: 18px;
        color: #ff303a;
    }

    .msg-success {
        border: 1px solid #6ac879;
        border-radius: 0.2rem;
        padding: 12px;
        background: #eeffed;
        margin-bottom: 18px;
        color: #009b0a;
    }

    /* end ofvalidation msg css */

    .msg-paragraph {
        font-size: 12px;
    }

    .msg-paragraph-con {
        color: #656d7d;
        font-size: 12px;
        margin-top: -15px;
    }

    .msg-paragraph-con2 {
        color: #656d7d;
        font-size: 12px;
        margin-top: 15px;
    }

    .form-text-align {
        text-align: center;
    }

    .country-header {
        margin-left: 26px;
    }

    span.individual {
        background: url("~@/assets/icon/user.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 9px;
    }

    span.family {
        background: url("~@/assets/icon/family.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 9px;
    }

    span.group {
        background: url("~@/assets/icon/group.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 5px;
    }

    span.single {
        background: url("~@/assets/icon/plane.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 12px;
    }

    span.multi {
        background: url("~@/assets/icon/planes.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 20px;
        width: 100%;
        margin-top: 12px;
        margin-bottom: 12px;
        margin-left: 2px;
    }

    span.world {
        background: url("~@/assets/icon/world.svg") no-repeat top left;
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 30px;
        width: 40px;
        margin-top: 5px;
        margin-bottom: 0px;
        margin-left: 10px;
    }

    span.fourty-five {
        /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 25px;
        width: 60px;
        margin-top: 2px;
        margin-bottom: 0px;
        margin-left: 1px;
    }

    span.ninety {
        /*background: url("~@/assets/icon/calendar.svg") no-repeat top left;*/
        background-size: contain;
        cursor: pointer;
        display: inline-block;
        height: 25px;
        width: 60px;
        margin-top: 2px;
        margin-bottom: 0px;
        margin-left: 1px;
    }

    .div-color {
        background-color: #fff;
        border-radius: 5px;
        width: 100%;
        padding: 0px 0px 0px 0px;
    }

    .div-button {
        display: inline-block;
        color: #444;
        border: 1px solid #4b78be;
        background: #fff;
        cursor: pointer;
        vertical-align: middle;
        width: 100%;
        padding: 15px 5px;
        border-radius: 0.3rem !important;
    }

    /*.div-button:active {
        color:red;
        box-shadow: 0 0 5px -1px rgba(0,0,0,0.6);
    }*/

    .world-area-text {
        margin-left: -5px;
        color: #4b78be;
    }

    .small-text {
        margin-top: -6px;
        color: #4b78be;
    }

    .small-text-middle {
        margin-right: -30px;
    }

    .small-text-last {
        margin-right: -30px;
    }

    .row-bottom {
        margin-bottom: 5px;
    }

    .row-bottom-tf {
        margin-bottom: 8px;
    }

    .btn-right {
        margin-right: 10px;
    }

    .btn-bottom {
        margin-bottom: 10px;
    }

    .col-width {
        width: 100px;
    }

    .col-width-d {
        width: 100px;
    }

    .col-width-m {
        width: 100px;
    }

    .col-width-y {
        width: 120px;
    }

    .globle-icon {
        margin-left: 12px;
        color: #4b78be;
        margin-top: 4px;
    }

    .form-group-bottom {
        margin-bottom: 0rem;
    }

    .modal-footer {
        display: none !important;
    }

    @media (max-width: 769px) {
        .label-name {
            margin-bottom: 25px;
            margin-top: 5px;
            font-weight: bold;
        }

        .label-align {
            text-align: left;
        }

        .btn-right {
            margin-right: 9px;
        }

        .world-area-button {
            width: 100%;
            margin-bottom: 15px;
        }

        .world-area-button {
            width: 100%;
            margin-bottom: 10px;
            margin-right: 0px;
        }

        img {
            width: 98px;
        }

        .btn-sq {
            width: 96px !important;
        }

        .btn-sqw {
            width: 96px !important;
        }

        span.world {
            margin-left: 16px;
        }

        .col-width-d {
            width: 108px;
            margin-right: -22px;
        }

        .col-width-m {
            width: 108px;
            margin-right: -22px;
        }

        .col-width-y {
            width: 108px;
        }
    }
</style>
